import { LineChart } from "@mui/x-charts/LineChart";
import { Box, Skeleton } from "@mui/material";

type DataPoint = {
  day: string;
  count: number;
};

type ChartData = DataPoint[];

const defaultChartData: ChartData = [
  { day: "07-28", count: 0 },
  { day: "07-27", count: 0 },
  { day: "07-26", count: 0 },
  { day: "07-25", count: 0 },
  { day: "07-24", count: 0 },
  { day: "07-23", count: 0 },
  { day: "07-22", count: 0 },
];

// Date formatter function to get "07-28" format
const formatXAxisLabel = (date: string): string => {
  if (!date || typeof date !== "string") return "";
  const [month, day] = date.split("-");
  return `${month}-${day}`;
};

const GoLineChart = ({ chartData = defaultChartData, isLoading }: { chartData?: ChartData; isLoading: boolean }) => {
  return isLoading ? (
    <BarChartSkeleton />
  ) : (
    <LineChart
      margin={{ left: 30, right: 10, top: 20, bottom: 20 }}
      xAxis={[
        {
          data: chartData.map((item) => item?.day),
          scaleType: "band",
          valueFormatter: formatXAxisLabel,
        },
      ]}
      series={[
        {
          data: chartData.map((item) => item?.count),
        },
      ]}
      height={210}
      grid={{ vertical: true, horizontal: true }}
      yAxis={[
        {
          valueFormatter: (value: number) => {
            if (value > 999) {
              return `${(value / 1000).toFixed(1)}K`;
            } else {
              return value.toString();
            }
          },
        },
      ]}
    />
  );
};

export default GoLineChart;

const BarChartSkeleton = () => {
  const barHeights = [100, 150, 120, 180, 90, 130, 160];

  return (
    <Box
      sx={{
        width: "100%",
        height: "210px",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-around",
        backgroundColor: "#f0f0f0",
        padding: "10px",
        borderRadius: "8px",
      }}
    >
      {barHeights.map((height, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width="40px"
          height={`${height}px`}
          sx={{
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
          }}
        />
      ))}
    </Box>
  );
};
